<template>
  <div
    class="layout hvf-single-exam-container"
    ref="wrapper"
    tabindex="0"
    @wheel.prevent="wheel"
    @keydown.up.prevent="scrollUp"
    @keydown.down.prevent="scrollDown"
    @keydown.right.prevent="nextHVFImage"
    @keydown.left.prevent="previousHVFImage">
    <v-flex hvf-image-view-wrapper
      :xs12="!showOD"
      :xs6="showOD"
      :order-xs1="hvfOrder"
      :order-xs2="!hvfOrder"
      v-if="showOS">
      <hvf-image-view
        eye="OS"
        :image="hvfOSImage"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @hvf_mousedown="mousedown"
        @hvf_mousemove="mousemove"
        @hvf_mouseup="mouseup"/>
    </v-flex>
    <v-flex hvf-image-view-wrapper
      :xs12="!showOS"
      :xs6="showOS"
      :order-xs1="!hvfOrder"
      :order-xs2="hvfOrder"
      v-if="showOD">
      <hvf-image-view
        eye="OD"
        :image="hvfODImage"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @hvf_mousedown="mousedown"
        @hvf_mousemove="mousemove"
        @hvf_mouseup="mouseup"/>
    </v-flex>
  </div>
</template>

<script>
import hvfImageView from "./HVFImageView";
import responsiveCanvases from "../../mixins/ResponsiveCanvases";
import hvfPositioning from "../../mixins/HVFPositioning";
import { EyeTypes } from "../../../config/config";
import { mapWatchers } from "../../../helpers/utils";
import { defaultSize } from "../../../canvas/geometry";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "hvfSingleExamContainer",
  components: { hvfImageView },
  mixins: [responsiveCanvases, hvfPositioning],
  computed: {
    ...mapGetters(["hvfEye", "hvfOSImage", "hvfODImage", "hvfOrder"]),
    isOU() {
      return this.hvfEye === EyeTypes.OU;
    },
    showOS() {
      return this.hvfEye === EyeTypes.OS || this.isOU;
    },
    showOD() {
      return this.hvfEye === EyeTypes.OD || this.isOU;
    },
    osImgSize() {
      return (this.hvfOSImage && this.hvfOSImage.imgSize) || defaultSize();
    },
    odImgSize() {
      return (this.hvfODImage && this.hvfODImage.imgSize) || defaultSize();
    },
    imgSize() {
      return this.showOS ? this.osImgSize : this.odImgSize;
    }
  },
  methods: {
    ...mapMutations(["previousHVFImage", "nextHVFImage"]),
    wheel(e) {
      let upOrForward = e.deltaY < 0;
      let switchImages = e.shiftKey || e.ctrlKey || e.altKey;

      if (switchImages && upOrForward) this.nextHVFImage();
      else if (switchImages) this.previousHVFImage();
      else if (upOrForward) this.scrollUp();
      else this.scrollDown();
    }
  },
  watch: {
    ...mapWatchers(["hvfEye", "odImgSize", "osImgSize"], function() {
      this.resetView(this._uid);
    })
  },
  mounted() {
    this.resetView(this._uid);
  }
};
</script>